<template>
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0">Tenaga Kerja IKM</h4>

            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <Link href="/admin/indagtenagakerjaikm">Tenaga Kerja IKM</Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="card-title">Manajemen Tenaga Kerja IKM</h4>
                  <p class="card-title-desc mb-0">Data Sentra Industri Kecil dan Menengah.</p>
                </div>
                <div>
                  <button type="button" class="btn btn-success" @click="tambah">Tambah Baru</button>
                </div>
              </div>

              <hr>

              <data-attribut :data="indagtenagakerja">
                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead>
                      <tr>
                        <th class="text-center" rowspan="2">No</th>
                        <th rowspan="2">Tahun</th>
                        <th rowspan="2">Nama Perusahaan / Pemilik</th>
                        <th class="text-center" colspan="3">Tenaga Kerja</th>
                        <th class="text-center" rowspan="2">Aksi</th>
                      </tr>
                      <tr>
                        <th>Pria</th>
                        <th>Wanita</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, index) in indagtenagakerja.data" :key="index">
                        <td scope="row" class="text-center">{{ indagtenagakerja.from + index }}</td>
                        <td scope="row" v-text="row.tahun"></td>
                        <td scope="row">
                          <div class="fw-bold" v-text="row.nama_perusahaan"></div>
                          <span v-text="row.kontak_person"></span>
                        </td>
                        <td scope="row" v-text="row.tenaga_kerja_pria"></td>
                        <td scope="row" v-text="row.tenaga_kerja_wanita"></td>
                        <td scope="row" v-text="row.tenaga_kerja_total"></td>
                        <td scope="row" class="text-center">
                          <a @click="edit(row)" class="p-0 btn btn-sm btn-link">Edit</a> |
                          <a @click="remove(row)" class="p-0 btn btn-sm btn-link">Hapus</a>
                        </td>
                      </tr>
                      <tr v-if="indagtenagakerja.data.length == 0">
                        <td scope="row" colspan="6" class="text-center">
                          <i>Tidak ditemukan data!</i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </data-attribut>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
    </div>
    <!-- container-fluid -->
  </div>

  <modal :show="form.show" @close="form.show = false" :title="(form.id ? 'Ubah' : 'Tambah') + ' Tenaga Kerja'"
    backdrop="static" size="xl">
    <template #default>
      <form @submit.prevent="action">

        <div class="d-flex">
          <div class="p-3 pt-0 flex-fill">
            <div class="mb-2 row" v-if="!form.ikmsearch || ikm.hasdata">
              <label for="nama_perusaaan" class="col-sm-2 col-form-label">Nama Perusahaan</label>
              <div class="col-sm-10">
                <input type="text" readonly
                  :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }"
                  id="nama_perusaaan" v-model="form.data.nama_perusahaan">
              </div>
            </div>

            <div class="mb-2 row" v-if="!form.ikmsearch || ikm.hasdata">
              <label for="kontak_person" class="col-sm-2 col-form-label">Kontak Person</label>
              <div class="col-sm-9">
                <input type="text" readonly
                  :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }" id="kontak_person"
                  v-model="form.data.kontak_person">
              </div>
              <div class="col-auto">
                <button class="btn btn-outline-danger" @click="ikm.hasdata = false" v-if="form.ikmsearch" type="button">X</button>
              </div>
            </div>

            <div v-if="form.ikmsearch && !ikm.hasdata">
              <form action="" method="post" @submit.prevent="cariIkm">
                <div class="d-flex gap-2 mb-2">
                  <input type="text" class="form-control" placeholder="Cari Data IKM ..." v-model="ikm.params.q">
                  <button class="btn btn-success" type="submit">
                    <icon :icon="['fa', 'search']" />
                  </button>
                </div>

                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>Perusahaan</th>
                        <th>Kontak</th>
                        <th>Jenis Usaha</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, i) in ikm.data" :key="`ikm-${i}`">
                        <td v-text="i + 1"></td>
                        <td v-text="row.nama_perusahaan"></td>
                        <td v-text="row.kontak_person"></td>
                        <td v-text="row.jenis_produk"></td>
                        <td>
                          <button class="btn btn-sm btn-outline-success" @click="pilihIkm(row)" type="button">Pilih</button>
                        </td>
                      </tr>
                      <tr v-if="ikm.data.length == 0">
                        <td scope="row" colspan="4" class="text-center">
                          <i>Tidak ditemukan data!</i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </form>

            </div>

            <hr>

            <div class="mb-2 row">
              <label for="kabupaten" class="col-sm-2 col-form-label">Tahun</label>
              <div class="col-sm-10">
                <input type="text" :readonly="form.readonly"
                  :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }"
                  id="kabupaten" v-model="form.data.tahun">
              </div>
            </div>

            <hr>

            <div class="row">
              <div class="col">
                <div class="mb-3">
                  <label for="tenaga_kerja_pria" class="form-label">Tenaga Kerja Pria</label>
                  <input type="number" :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }" v-model="form.data.tenaga_kerja_pria" id="tenaga_kerja_pria">
                </div>
              </div>
              <div class="col">
                <div class="mb-3">
                  <label for="tenaga_kerja_wanita" class="form-label">Tenaga Kerja Wanita</label>
                  <input type="number" :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }" v-model="form.data.tenaga_kerja_wanita" id="tenaga_kerja_wanita">
                </div>
              </div>
              <div class="col">
                <div class="mb-3">
                  <label for="total_tenaga_kerja" class="form-label">Total Tenaga Kerja</label>
                  <input type="number" :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }" v-model="form.data.tenaga_kerja_total" id="total_tenaga_kerja">
                </div>
              </div>
            </div>

          </div>

          <div>
            <div class="d-grid gap-2 flex-row">
              <button type="button" v-if="form.readonly && form.id" @click="form.readonly = false"
                class="btn btn-outline-success">Ubah</button>
              <button type="submit" v-if="!form.readonly" class="btn btn-success">Simpan</button>
              <button type="button" v-if="!form.readonly && form.id" @click="form.readonly = true"
                class="btn btn-danger">Batal</button>
            </div>
          </div>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
import Layout from '@/layout/Index'
import Modal from '@/components/Modal'
import DataAttribut from '@/components/DataAttribut'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import axios from 'axios'

export default {
  layout: Layout,
  components: { Modal, DataAttribut },
  props: {
    indagtenagakerja: Object
  },
  data() {
    return {
      ikm: {
        hasdata: false,
        params: {
          q: '',
        },
        data: []
      },
      form: {
        show: false,
        id: null,
        readonly: true,
        ikmsearch: false,
        data: {}
      },
    }
  },
  methods: {
    cariIkm() {
      if(this.ikm.params.q) {
        axios.get('/admin/indagikm', {
          params: this.ikm.params
        })
        .then(res => {
          this.ikm.data = res.data.indagikm.data;
        }).catch(() => {});
      } else {
        this.ikm.data = [];
      }
    },
    pilihIkm(row) {
      this.form.data.nama_perusahaan = row.nama_perusahaan;
      this.form.data.kontak_person = row.kontak_person;
      this.form.data.ikm_id = row.id;
      this.ikm.hasdata = true;
    },
    tambah() {
      this.form.id = null;
      this.form.show = true;
      this.form.readonly = false;
      this.form.data = {};
      this.form.ikmsearch = true;
      this.ikm.hasdata = false;
    },
    edit({ id }) {
      this.form.id = id;
      this.form.show = true;
      this.form.readonly = true;
      this.form.ikmsearch = false;
      axios.get('/admin/indagtenagakerjaikm/' + id)
        .then(res => {
          this.form.data = res.data.indagtenagakerja || {};
        })
    },
    action() {
      const onSuccess = () => {
        this.form.show = false;
        this.form.id = null;
        this.form.ikm_id = null;
        this.form.data = {};
      }
      if (this.form.id) {
        this.$inertia.put('/admin/indagtenagakerjaikm/' + this.form.id, this.form.data, { onSuccess });
      } else {
        this.$inertia.post('/admin/indagtenagakerjaikm', this.form.data, { onSuccess });
      }
    },
    remove(row) {
      if(confirm('Konfirmasi Proses Penghapusan?'))
      this.$inertia.delete('/admin/indagtenagakerjaikm/' + row.id);
    }
  },
}
</script>
